/**
* @license Apache-2.0
*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

/**
* Return a regular expression to match a native function.
*
* @module @stdlib/regexp-native-function
*
* @example
* var reNativeFunction = require( '@stdlib/regexp-native-function' );
*
* var RE_NATIVE_FUNCTION = reNativeFunction();
* function isNativeFunction( fcn ) {
*     return RE_NATIVE_FUNCTION.test( fcn.toString() );
* }
*
* var bool = isNativeFunction( Math.sqrt );
* // returns true
*
* bool = isNativeFunction( Int8Array );
* // returns true
*
* bool = isNativeFunction( Object.prototype.toString );
* // returns true
*
* bool = isNativeFunction( function noop() {} );
* // returns false
*/


// MAIN //

var setReadOnly = require( '@stdlib/utils-define-nonenumerable-read-only-property' );
var main = require( './main.js' );
var REGEXP = require( './regexp.js' );


// MAIN //

setReadOnly( main, 'REGEXP', REGEXP );


// EXPORTS //

module.exports = main;
